import React from "react";
import UserMainPage from "../../components/UserHomePage/UserMainPage";

function UserHomePage() {
  return (
    <div>
      <UserMainPage />
    </div>
  );
}

export default UserHomePage;
